import { render, staticRenderFns } from "./AboutAgent.vue?vue&type=template&id=08fb260c&"
import script from "./AboutAgent.vue?vue&type=script&lang=js&"
export * from "./AboutAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports